import { COMPONENTI, PIANI } from "../lib/format";
import { TextField, SelectField, Field } from "./Field";
import { Checkbox } from "./ui/checkbox";

const PIANO_OPTIONS = [...Object.keys(PIANI), "Personalizzata"].map((p) => ({ value: p, label: p }));
const isCustomPiano = (piano) => Boolean(piano) && !PIANI[piano];

const pianoSelectValue = (piano) => {
  if (PIANI[piano]) return piano;
  return piano ? "Personalizzata" : "";
};

export const veicoloPlaceholder = (clienteId, count) => {
  if (!clienteId) return "Prima il cliente";
  return count ? "Seleziona" : "Nessun veicolo per il cliente";
};

export const PianoFields = ({ piano, onPick, onName }) => (
  <>
    <SelectField label="Piano" value={pianoSelectValue(piano)} onChange={onPick} testId="garanzia-piano-select" options={PIANO_OPTIONS} />
    {isCustomPiano(piano)
      ? <TextField label="Nome piano" value={piano === "Personalizzata" ? "" : piano} onChange={(v) => onName(v || "Personalizzata")} testId="garanzia-piano-nome-input" />
      : <div className="hidden sm:block" />}
  </>
);

export const DurataConformita = ({ value, onChange }) => (
  <SelectField label="Durata conformità" value={String(value)} onChange={(v) => onChange(Number(v))} testId="garanzia-durata-conformita-select" className="sm:col-span-2"
    options={[{ value: "12", label: "12 mesi (usato, se concordato)" }, { value: "24", label: "24 mesi (standard)" }]} />
);

export const CommercialeFields = ({ f, set }) => (
  <>
    <TextField label="Limite km (0 = illimitati)" type="number" value={f.km_limite} onChange={set("km_limite")} testId="garanzia-km-limite-input" />
    <TextField label="Massimale per sinistro (€)" type="number" value={f.massimale} onChange={set("massimale")} testId="garanzia-massimale-input" />
    <TextField label="Franchigia (€)" type="number" value={f.franchigia} onChange={set("franchigia")} testId="garanzia-franchigia-input" />
    <TextField label="Prezzo al cliente (€)" type="number" value={f.prezzo} onChange={set("prezzo")} testId="garanzia-prezzo-input" />
  </>
);

export const ComponentiPicker = ({ selected, onToggle }) => (
  <Field label="Componenti coperti" className="sm:col-span-2">
    <div className="grid grid-cols-2 gap-2 rounded-md border p-3 sm:grid-cols-3">
      {COMPONENTI.map((c) => (
        <label key={c} className="flex cursor-pointer items-center gap-2 text-sm">
          <Checkbox checked={selected.includes(c)} onCheckedChange={() => onToggle(c)} data-testid={`garanzia-comp-${c.replace(/\s+/g, "-").toLowerCase()}`} /> {c}
        </label>
      ))}
    </div>
  </Field>
);
